import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { Easings } from '@picsart/design-system/foundation/easings';

const CARD_WIDTH = 156;
const TITLE_BAR_HEIGHT = 20;
const SEE_ALL_WIDTH = 72;

const useStyles = createUseStyles(
  {
    '@keyframes shimmer': {
      '0%': { transform: 'translateX(-100%)' },
      '100%': { transform: 'translateX(100%)' },
    },
    container: {
      height: '100%',
      overflowY: 'hidden',
      paddingBlock: Spacings.s16,
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      marginBottom: Spacings.s24,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: Spacings.s16,
      paddingRight: Spacings.s16,
    },
    shimmer: {
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: BackgroundColors.base,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(90deg, transparent 0%, ${BackgroundColors.tint2} 50%, transparent 100%)`,
        animation: `$shimmer 1.2s ${Easings.easeInOut} infinite`,
        willChange: 'transform',
      },
    },
    titleBar: {
      width: '40%',
      height: TITLE_BAR_HEIGHT,
      borderRadius: CornerRadius.r4,
    },
    seeAll: {
      width: SEE_ALL_WIDTH,
      height: TITLE_BAR_HEIGHT,
      borderRadius: CornerRadius.r4,
    },
    row: {
      display: 'flex',
      gap: Spacings.s12,
      overflow: 'hidden',
      paddingLeft: Spacings.s16,
      paddingRight: Spacings.s16,
    },
    cell: {
      flex: '0 0 auto',
      width: CARD_WIDTH,
      aspectRatio: '3 / 4',
      borderRadius: CornerRadius.r12,
    },
  },
  { name: 'CategoryRowsSkeleton' }
);

export default useStyles;
